module.exports = __webpack_public_path__ + "static/media/newsreader-compose.363c5ccf.png";